// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2rePr","rootSmall":"AddTileButton_rootSmall__25OMT"};